var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#D9D9D9",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 19H12C11.7167 19 11.4792 18.9042 11.2875 18.7125C11.0958 18.5208 11 18.2833 11 18C11 17.7167 11.0958 17.4792 11.2875 17.2875C11.4792 17.0958 11.7167 17 12 17H17V12C17 11.7167 17.0958 11.4792 17.2875 11.2875C17.4792 11.0958 17.7167 11 18 11C18.2833 11 18.5208 11.0958 18.7125 11.2875C18.9042 11.4792 19 11.7167 19 12V17H24C24.2833 17 24.5208 17.0958 24.7125 17.2875C24.9042 17.4792 25 17.7167 25 18C25 18.2833 24.9042 18.5208 24.7125 18.7125C24.5208 18.9042 24.2833 19 24 19H19V24C19 24.2833 18.9042 24.5208 18.7125 24.7125C18.5208 24.9042 18.2833 25 18 25C17.7167 25 17.4792 24.9042 17.2875 24.7125C17.0958 24.5208 17 24.2833 17 24V19Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCardIcon);
export default __webpack_public_path__ + "static/media/AddCardIcon.960f569ca5b70f92539bd3744cd78754.svg";
export { ForwardRef as ReactComponent };